import { render } from "./practiceContent.vue?vue&type=template&id=2f6af06a"
import script from "./practiceContent.vue?vue&type=script&lang=js"
export * from "./practiceContent.vue?vue&type=script&lang=js"

import "./practiceContent.vue?vue&type=style&index=0&id=2f6af06a&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__